<template>
  <TabPanels
    class="form bg-gray-100 flex flex-col flex-1"
    :class="{
      'overflow-hidden': pageLayout.shouldLock.value
    }"
  >
    <slot></slot>
  </TabPanels>
</template>

<script setup>
import { useLayoutState } from '@/Layouts/layout-state'
import { TabPanels } from '@headlessui/vue'

const pageLayout = useLayoutState()
</script>
